import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { ComponentTheme, ComponentThemeTint } from '@helpers/themeEnum';
import { contentStyles, h5 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div `
  padding: ${fluid(32, 80)} ${fluid(30, 117)};
  border-radius: ${fluid(25, 50)};
  --bgColour: ${brand.blue.tint};
  background-color: var(--bgColour);

  @media ${from(Device.TabletSmall)} {
    ${baseGrid};
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${fluid(44, 80)};
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: repeat(3, 1fr);
  }

  &[data-theme=${ComponentTheme.Blue}] {
    --bgColour: ${brand.blue.tint};

    &[data-tint='${ComponentThemeTint.ThirtyPercent}'] {
      --bgColour: ${brand.blue.light};
    }

    &[data-tint='${ComponentThemeTint.OneHundredPercent}'] {
      --bgColour: ${brand.blue.base};
    }
  }

  &[data-theme=${ComponentTheme.Green}] {
    --bgColour: ${brand.green.tint};

    &[data-tint='${ComponentThemeTint.ThirtyPercent}'] {
      --bgColour: ${brand.green.light};
    }

    &[data-tint='${ComponentThemeTint.OneHundredPercent}'] {
      --bgColour: ${brand.green.base};
    }
  }

  &[data-theme=${ComponentTheme.Orange}] {
    --bgColour: ${brand.orange.tint};

    &[data-tint='${ComponentThemeTint.ThirtyPercent}'] {
      --bgColour: ${brand.orange.light};
    }

    &[data-tint='${ComponentThemeTint.OneHundredPercent}'] {
      --bgColour: ${brand.orange.base};
    }
  }

  &[data-theme=${ComponentTheme.Yellow}] {
    --bgColour: ${brand.yellow.tint};

    &[data-tint='30%'] {
      --bgColour: ${brand.yellow.light};
    }

    &[data-tint='100%'] {
      --bgColour: ${brand.yellow.base};
    }
  }
`;
const Statistic = styled.div `
  @media ${until(Device.TabletSmall)} {
    &:not(:first-child) {
      padding-top: 38px;
    }
  }
`;
const StatisticTitle = styled.h2 `
  ${h5};

  @media ${until(Device.TabletSmall)} {
    margin-bottom: 16px;
  }
`;
const StatisticContent = styled.div `
  ${contentStyles};
`;
export const StatisticsCallOutStyles = {
    Container,
    Inner,
    Statistic,
    StatisticContent,
    StatisticTitle,
};
